var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gb-ant-button-count-down"},[_c('a-button',_vm._b({staticClass:"btn-count-down",attrs:{"disabled":_vm.btnDisabled},on:{"click":_vm.handleClick}},'a-button',_vm.$attrs,false),[_vm._v(_vm._s(_vm.timeStartText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }